import { AcceptUserAgreementsResult } from '@varo/graphql-schema-types';
import {
  isAcceptUserAgreementGqlError,
  isAcceptUserAgreementSuccess,
} from 'features/advance/helpers/Advance.helpers';
import AcceptUserAgreements from 'services/graphql/mutations/MoveMoney/AcceptUserAgreements';
import useCancellableMutation from 'shared/hooks/useCancellableMutation';

const useSubmitAgreement = () => {
  const [
    {
      data: submitAcceptedAgreementData,
      error: submitAcceptedAgreementNetworkError,
      fetching: submitAcceptedAgreementFetching,
    },
    submitAcceptedAgreement,
  ] = useCancellableMutation<{
    acceptUserAgreements: AcceptUserAgreementsResult;
  }>(AcceptUserAgreements);

  const acceptedAgreementSuccess = isAcceptUserAgreementSuccess(
    submitAcceptedAgreementData?.acceptUserAgreements,
  )
    ? submitAcceptedAgreementData.acceptUserAgreements
    : null;

  const acceptedAgreementError = isAcceptUserAgreementGqlError(
    submitAcceptedAgreementData?.acceptUserAgreements,
  )
    ? submitAcceptedAgreementData?.acceptUserAgreements
    : null;

  const hasError =
    submitAcceptedAgreementNetworkError || acceptedAgreementError;
  return {
    isAgreementAccepted: acceptedAgreementSuccess?.accepted,
    submitAgreement: submitAcceptedAgreement,
    fetching: submitAcceptedAgreementFetching,
    hasError,
  };
};

export default useSubmitAgreement;
